<template>
  <div>
    <v-table
      class="raceTable"
      is-horizontal-resize
      :columns="columns"
      :table-data="tableData"
      :show-vertical-border="true"
      :title-bg-color="'#7ef8fc'"
      :title-row-height="30"
      :border="1"
      row-hover-color="#eee"
      :row-click="raceDetail"
      style="width:100%"
    ></v-table>
    <a href="#"  class="btn btn--primary" @click="deleteLocationData">Delete Location Data</a></div>
</template>

<script>
import 'vue-easytable/libs/themes-base/index.css'
import {VTable, VPagination} from 'vue-easytable'
import Vue from "vue"
import moment from 'moment'
import {db, deleteLocationData} from '../../firebase'

Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
export default {
  name: 'race-table-list',
  data: () => ({
    pastRaces: [],
    tableData: [],
    columns: [],
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    totalRunner: null
  }),
  props: {
    races: {
      type: Array,
      required: true
    },
    messageEmptyList: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    }
  },
  methods: {
    deleteLocationData() {
      //load top 100 records from locations from firebase
      var locationIds = db.ref("/locations/").limitToFirst(100);
      //for each location
      locationIds.once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          //if location has property procesed true then delete locationData node in location
          if (childSnapshot.val().processed) {
            db.ref("/locations/").child(childSnapshot.key).child("locationData").remove().then(r => {
              console.log("Node deleted >>>" + childSnapshot.key);
            });
          }
        });
      });

      // var id = 26892;
      // var runners = db.ref("/locations/").child(id).child("runners");
      // //for each runner
      // runners.once('value', function (snapshot) {
      //   snapshot.forEach(function (childSnapshot) {
      //     //if runnder has property procesed true then delete locationData node in runner
      //     if (childSnapshot.val().processed) {
      //       db.ref("/locations/").child(id).child("runners").child(childSnapshot.key).child("locationData").remove().then(r => {
      //         console.log("Node deleted >>>" + childSnapshot.key);
      //       });
      //     }
      //   });
      // });
    },
    getRacesInfo() {
      const pastRuns = this.races.map((race) => {
        let totalRunner = 0

        db.ref(`/${this.$fbDbEntry}/${race.id}/runners`)
          .on('value', (runnersFirebase) => {

            const runnersObject = runnersFirebase.val()

            if (runnersObject) {
              totalRunner = Object.keys(runnersObject).length
            }
          })

        return {
          id: race.id,
          duration: race.duration,
          name: race.name,
          trainerName: race.trainer.firstName,
          date: moment(race.finishDate).format('YYYY/MM/DD'),
          day: this.weekdays[moment(race.date).day()],
          startTime: moment(race.startDate).format('h:mm A'),
          totalRunner: totalRunner
        }
      })
      pastRuns.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date)
      })

      this.tableData = pastRuns

      this.columns = [
        {field: "date", title: 'Date', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "day", title: 'Day', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "startTime", title: 'Start Time', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "name", title: 'Name', width: 190, titleAlign: 'center', columnAlign: 'center', isResize: true},
        {field: "duration", title: 'Duration min', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "totalRunner", title: 'Total Runners', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {
          field: "trainerName",
          title: 'Trainer',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center',
          isResize: true
        },
        {
          field: "action",
          title: 'Action',
          width: 100,
          titleAlign: 'center',
          columnAlign: 'center',
          componentName: 'view-run-link'
        }
      ]
    },
    raceDetail(newValue, raceData) {
      this.$router.push({
        name: 'past-run',
        params: {pastRun: true, raceId: raceData.id}
      })
    }
  },
  created() {
    this.getRacesInfo()
  },
  watch: {
    races() {
      this.getRacesInfo()
    }
  }
}

Vue.component('view-run-link', {
  template: `
    <div>
      <a 
        href="#" 
        @click.stop.prevent="viewRun()" 
        style="color: #423799; text-decoration: underline; cursor: pointer; font-weight: 500;"
      >
        View Run
      </a>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    viewRun() {
      const raceId = this.rowData.id
      const url = `${window.location.origin}/#/admin/live-run/race/${raceId}`
      window.open(url, '_blank')
    }
  }
})
</script>
<style>
.raceTable tr.v-table-row {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// RaceTableList.vue?55ab22ea